import { render, staticRenderFns } from "./videoBase.vue?vue&type=template&id=35cb3d78&scoped=true"
import script from "./videoBase.vue?vue&type=script&lang=js"
export * from "./videoBase.vue?vue&type=script&lang=js"
import style0 from "./videoBase.vue?vue&type=style&index=0&id=35cb3d78&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cb3d78",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35cb3d78')) {
      api.createRecord('35cb3d78', component.options)
    } else {
      api.reload('35cb3d78', component.options)
    }
    module.hot.accept("./videoBase.vue?vue&type=template&id=35cb3d78&scoped=true", function () {
      api.rerender('35cb3d78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BaseTemplate/videoBase.vue"
export default component.exports